import { render, staticRenderFns } from "./GradingTables.vue?vue&type=template&id=67b41468&"
import script from "./GradingTables.vue?vue&type=script&lang=js&"
export * from "./GradingTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports